import React from 'react'

import CtaButton from '../CtaButton'

//const TicketOption = ({type, available, info}) => (



    class TicketOption extends React.Component {
        render(){

        const { type, available, info } = this.props;

        if (available === "out"){
            return(
                <li>
                    <div className="tickets-item">
                        <div>
                            <h3 className="tickets-type tickets-unavailable_type">{type}</h3>
                            {info &&
                                <p className="item-text tickets-info">{info}</p>
                            }
                        </div>
                        <span className="item-text">Sold out!</span>
                    </div>
                </li>
            )
        } else {
            if (available === true){
                return(
                    <li>
                        <div className="tickets-item">
                            <div>
                                <h3 className="tickets-type">{type}</h3>
                                {info &&
                                    <p className="item-text tickets-info">{info}</p>
                                }
                            </div>
                            <CtaButton className="tickets-cta" href="https://cssconfar.eventbrite.com.ar" text="Purchase" />
                        </div>
                    </li>
                )
            } else {
                return(
                    <li>
                        <div className="tickets-item">
                            <div>
                                <h3 className="tickets-type tickets-unavailable_type">{type}</h3>
                                {info &&
                                    <p className="item-text tickets-info">{info}</p>
                                }
                            </div>
                            <span className="item-text">Available soon!</span>
                        </div>
                    </li>
                )
            }
        }
    }
}

export default TicketOption



// WEBPACK FOOTER //
// ./src/components/TicketOption/index.js